import { type TipoDomandaDTO } from '@framework/api-client/api/inquiries/schemas/tipoDomandaDTO.ts';
import { InquiryTypeTranslationSchema } from './InquiryTypeTranslationSchema.ts';

/**
 * Transformer utilizzato nelle chiamate API per applicare le traduzioni a una
 * singola domanda.
 */
export function selectTranslatedInquiryType(data: TipoDomandaDTO) {
  return InquiryTypeTranslationSchema.translate(data, data.traduzioni ?? []);
}
